

export enum ReportReason {
    FAKE_PROFILE = 'FAKE_PROFILE',
    UNDER_18 = 'UNDER_18',
    NUDITY = 'NUDITY',
    ABUSE = 'ABUSE',
    PHYSICAL_HARM = 'PHYSICAL_HARM',
    OTHER = 'OTHER',
    BGC = 'BGC'
}